import { PAGE_ROUTES } from "../constants/pages";

interface BreadcrumbConfig {
  isScheduleBeforeCredit: boolean;
}

interface Breadcrumb {
  name: string;
  route: string;
}

const STEP_INDEX = {
  BAU: {
    PLAN: 0,
    CONTACT: 1,
    INSTALLATION: 2,
    PAYMENT: 3,
  },
  IBC: {
    PLAN: 0,
    INSTALLATION: 1,
    CONTACT: 2,
    PAYMENT: 3,
  },
  C2F: {
    CHOOSE_PLAN: 0,
    COMPLETE_ORDER: 1,
  },
};

/**
 * Standard order flow routes
 */
const STANDARD_BREADCRUMBS: Breadcrumb[] = [
  {
    name: "Plan",
    route: PAGE_ROUTES.PLAN_PACKAGE,
  },
  {
    name: "Contact",
    route: PAGE_ROUTES.CONTACT_CREDIT,
  },
  {
    name: "Installation",
    route: PAGE_ROUTES.INSTALLATION,
  },
  {
    name: "Payment",
    route: PAGE_ROUTES.BILLING_SUMMARY,
  },
];

/**
 * C2F order flow routes
 */
const C2F_BREADCRUMBS: Breadcrumb[] = [
  {
    name: "Choose plan",
    route: PAGE_ROUTES.PLAN_PACKAGE,
  },
  {
    name: "Complete order",
    route: PAGE_ROUTES.BILLING_SUMMARY,
  },
];

/**
 * Generates breadcrumbs based on the provided configuration
 * @param config - Configuration for breadcrumb generation
 * @returns Array of breadcrumb items
 */
const getBreadcrumbs = ({ isScheduleBeforeCredit }: BreadcrumbConfig): Breadcrumb[] => {
  if (isScheduleBeforeCredit) {
    const [plan, contact, installation, payment] = STANDARD_BREADCRUMBS;
    return [plan, installation, contact, payment];
  }

  return STANDARD_BREADCRUMBS;
};

const getCurrentDesktopStepIndex = (
  route: string,
  isScheduleBeforeCredit: boolean,
  accordionStep?: number,
  c2fEnabled?: boolean
): number => {
  const breadcrumbs = c2fEnabled ? C2F_BREADCRUMBS : getBreadcrumbs({ isScheduleBeforeCredit });
  let currentIndex = breadcrumbs.findIndex((b) => b.route === route);

  if (route.includes(PAGE_ROUTES.BILLING_SUMMARY) && !isScheduleBeforeCredit && !c2fEnabled) {
    if (accordionStep === 1) {
      currentIndex = breadcrumbs.findIndex((b) => b.name === "Installation");
    }
    if (accordionStep === 2) {
      currentIndex = breadcrumbs.findIndex((b) => b.name === "Payment");
    }
  }

  return currentIndex;
};

const getCurrentMobileStepIndex = (route: string, isScheduleBeforeCredit: boolean, accordionStep?: number): number => {
  const breadcrumbs = getBreadcrumbs({ isScheduleBeforeCredit });
  let currentIndex = breadcrumbs.findIndex((b) => b.route === route);

  if (route.includes(PAGE_ROUTES.CHECKOUT)) {
    if (accordionStep === 1) {
      currentIndex = breadcrumbs.findIndex((b) => (isScheduleBeforeCredit ? "Installation" : "Contact") === b.name);
    }
    if (accordionStep === 2) {
      currentIndex = breadcrumbs.findIndex((b) => (isScheduleBeforeCredit ? "Contact" : "Installation") === b.name);
    }
    if (accordionStep === 3) {
      currentIndex = breadcrumbs.findIndex((b) => b.name === "Payment");
    }
  }

  return currentIndex;
};

export { STEP_INDEX, C2F_BREADCRUMBS, getBreadcrumbs, getCurrentDesktopStepIndex, getCurrentMobileStepIndex };
export type { Breadcrumb, BreadcrumbConfig };
